import { useContext } from 'react';

import usePreviewManager from './usePreviewManager';

/**
 * @example const { previewTriggerRef } = usePreviewContext();
 * @returns Context<PreviewContextValue>
 */
const usePreviewContext = () => {
  const { PreviewContext } = usePreviewManager();
  return useContext(PreviewContext);
};

export default usePreviewContext;
